module.exports = __webpack_public_path__ + "img/body_bg.7c082270.png";